import React, { useState, useEffect, useRef } from "react";
import QuestionTable from './question-table'; 
import { useNavigate } from 'react-router-dom';
import AppTopBar2 from './common/app-top-bar2';
import AppLoading from './common/app-loading';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {
  CircularProgress, Button, Box, Divider, List, ListItem, ListItemButton, 
  Select, Typography, MenuItem, FormControl, InputLabel, TextField, Grid,
  TableCell, TableHead, TableRow, TableSortLabel,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import LinearProgress from '@mui/material/LinearProgress';
import { AppHelper } from '../AppHelper';
import SpaCheck from './common/spa-check';

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box>
        <Typography variant="body2" color="text.secondary" fontSize={"0.7rem"}
          sx={{
            color: props.recSelected == 1 ? '#fff' : 'text.secondary'
          }}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function ImageDialog({ open, imageUrls, onClose, topic }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>View Question</DialogTitle>
      <DialogContent>
        <Grid container direction="column" spacing={3}>

          <Grid item xs={12}>
            <div dangerouslySetInnerHTML={{ __html: topic }} />
          </Grid>

          {imageUrls ? (
            imageUrls.map((imageUrl, index) => (
              <Grid item key={index} xs={6} sm={4} md={3}>
                <img
                  src={`data:image/jpeg;base64,${imageUrl}`}
                  alt={`Image ${index + 1}`}
                  style={{ maxWidth: '100%' }}
                />
              </Grid>
            ))
          ) : (
            <CircularProgress />
          )}
        </Grid>
      </DialogContent>
      <Button onClick={onClose} style={{ position: 'absolute', top: 0, right: 0 }}>
        <CloseIcon />
      </Button>
    </Dialog>

  );
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const headCellsEssay = [
  { id: 'createdOn', numeric: false, disablePadding: false, label: 'TIMESTAMP' },
  { id: 'uploadType', numeric: false, disablePadding: false, label: 'OWNERSHIP' },
  { id: 'title', numeric: false, disablePadding: false, label: 'TITLE' },
  { id: 'topic', numeric: false, disablePadding: false, label: 'TOPIC' },
  { id: 'grade', numeric: false, disablePadding: false, label: 'GRADE' },
  { id: 'images', numeric: false, disablePadding: false, label: 'HAS IMAGE' },
  { id: 'createdByName', numeric: false, disablePadding: false, label: 'CREATED BY' },
  { id: 'actions', numeric: false, disablePadding: false, label: 'ACTIONS' }

];

export default function PageSaQuestionList() {
  const navigate = useNavigate();
  const oUser = AppHelper.userCacheGet();
  const [popQuestionOpen, setPopQuestionOpen] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [logList, setLogList] = useState([]);
  const [mode, setMode] = useState(null);
  const [isAddQuestion, setIsAddQuestion] = useState(false);

  const onAddQuestion = () => {	
    setMode('add');
    setIsAddQuestion(true);
    setSelectedRow(null);
    setPopQuestionOpen(true);
  }

  const popQuestionClose = (refresh) => {	
    setMode(null);
    setRefreshList(refresh);
	setPopQuestionOpen(false);
  }

  useEffect(() => {
    AppHelper.apiAuditPost("P-QU", "");
    var _user = AppHelper.userCacheGet();
    if (_user) {
      fetchIAM(_user);
	  
    }
  }, []);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const [viewMode, setViewMode] = React.useState('LIST');
  const [refreshList, setRefreshList] = React.useState(true);
  const [countEssay, setCountLog] = React.useState(0);

  const [tblOrderLog, setTblOrderLog] = React.useState('desc');
  const [tblOrderByLog, setTblOrderByEssay] = React.useState('tCode');
  const [filterLog, setFilterLog] = React.useState('');
  const [isSa, setIsSa] = useState(false);

  const fetchIAM = async (oUser) => {
    var _res = await AppHelper.apiPost('api/account/iam', { token: oUser.token });
    if (!_res || !_res.status || !_res.data || !_res.data.isSa) {
      return;
    }
    setIsSa(true);
  }

  useEffect(() => {
    if (!oUser) {
      navigate('/login');
      return;
    }
  });

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [questionType, setQuestionType] = useState('Essay');

  const handleQuestionTypeChange = (event) => {
    setQuestionType(event.target.value);
  };

  const handleCloseDialog = () => {
    setSelectedTopic("");
    setIsPopupOpen(false);
    setImageUrls([]);
  };

  const fetchLogList = async () => {
	var _res = await AppHelper.apiPost('api/account/iam', { token: oUser.token });
    logList.splice(0);
    setIsLoading(true);
    var url = 'api/question/list';

    if (_res && _res.status && _res.data && _res.data.isSa) {
      url = 'api/question/list/all';
    }
	else{
	  url = 'api/question/list';
	}

    var _res = await AppHelper.apiPost(url, { token: oUser.token, includeImage:0 });
    if (!_res || !_res.status) {
      setIsLoading(false);
      return;
    }
    var _list = [...AppHelper.sortList(_res.questionList, 'createdOn', 2)];
    setLogList(_list);
    setIsLoading(false);
    setCountLog(_list.length);
    setRefreshList(false);
  };

  useEffect(() => {
    if(refreshList)
	{	
		fetchLogList();
	}

  }, [refreshList]);

  const drawerItemColrs = {
    '1x': 'rgba(0,0,0,0.25)',
    '1xx': 'rgb(157, 188, 152)',
    '1': 'rgb(99, 136, 137)',
    '0x': 'white',
    '0': 'rgb(235, 217, 180)',
  };
  const drawerItemColorsText = {
    '1': 'rgba(255,255,255,1)',
    '0': 'rgba(0,0,0,0.6)',
  };
  const mobileOpenClick = (arg) => {
    setMobileOpen(!mobileOpen);
  };
  
  const listSortAndFilterEssay = () => {
    var _list = [...logList];
    if (filterLog && filterLog.length > 0) {
      var _filterText = filterLog.toLowerCase();
      _list = _list.filter(r =>
        r.topic.toLowerCase().includes(_filterText)
        || (r.title && r.title.toLowerCase().includes(_filterText))
        || (r.grade && r.grade.toLowerCase().includes(_filterText))
        || (r.createdByName && r.createdByName.toLowerCase().includes(_filterText))

      );
    }
    _list.forEach(r => {
      r.topicView = r.topic;
      const words = r.topicView.split(' ');
      if (words.length > 10) {
        r.topicView = words.slice(0, 10).join(' ') + '...';
      }
    });
    return stableSort(_list, getComparator(tblOrderLog, tblOrderByLog));
  };
  const filterLogChange = (event) => {
    setFilterLog(event.target.value);
  };
  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} />
        {isLoading ? (
          <AppLoading />
        ) : (
          <>
            <Box
              component="main"
              sx={{
                flexGrow: 1, p: 3,
                width: '100%',
                marginTop: '50px'
              }}
            >
              {viewMode == 'LIST' &&
                <>
                 <Grid container alignItems="center" spacing={0}>
					 <Grid item xs={6} sm={6}>
					  {/* Dropdown for question type */}
					  <FormControl fullWidth variant="standard">
						<InputLabel id="question-type-label">Question Type</InputLabel>
						<Select
						  labelId="question-type-label"
						  id="question-type-select"
						  value={questionType}
						  onChange={handleQuestionTypeChange}
              sx={{ width: '300px', marginRight: '16px' }}
						>
						  <MenuItem value="Essay">Essay</MenuItem>
						</Select>
					  </FormControl>
					</Grid>

					  <Grid item xs={6} sm={6}>
						<Box display="flex" justifyContent="flex-end" alignItems="center">
						  <TextField
							value={filterLog}
							onChange={filterLogChange}
							id="txtFilterLog"
							label=""
							variant="standard"
							placeholder="Search"
							sx={{ width: '300px', marginRight: '16px' }} // Increased width and added space between elements
						  />
						  <Button
							onClick={() => onAddQuestion()}
							className="app-btn-bg"
							color="info"
							variant="contained"
							size="large"
							style={{ marginBottom: '8px' }}
						  >
							ADD QUESTION
						  </Button>
						</Box>
					  </Grid>
					</Grid>
                   {questionType === 'Essay' ? (
						<QuestionTable
						  filterLog={filterLog}
						  popQuestionOpenParam={popQuestionOpen}
						  onClose={popQuestionClose}
              isAddQuestion={isAddQuestion}
						/>
					  ) : null}
                </>
              }
            </Box>
            <ImageDialog open={isPopupOpen} topic={selectedTopic} imageUrls={imageUrls} onClose={handleCloseDialog} />
          </>
        )}
        <SpaCheck></SpaCheck>
      </Box>
    </>
  );
}
